'use client';

import { __assign } from '../_virtual/_tslib.js';
import React__default, { useState, useRef, useEffect } from 'react';
import { Wrapper, SelectContainer, ValueContainer, ArrowDownContainer, Value, Placeholder } from './MultipleRadio.css.js';
import { MultipleRadioGroupContext } from './context.js';
import useFloating from '../hooks/useFloating/index.js';
import useClickAway from '../hooks/useClickAway.js';
import '../hooks/useMakeSearchable/types.js';
import { ELanguage } from '../Utils/constants.js';
import '../services/resumes/types.js';
import ArrowDownIcon from '../Images/ArrowDownIcon/index.js';
import SortMobileIcon from '../Images/SortMobileIcon/index.js';
import Dropdown from './Dropdown/index.js';
import MobileDialog from './MobileDialog/index.js';
import PopupBottom from './PopupBottom/index.js';

var MultipleRadio = function (_a) {
    var _b, _c, _d, _e, _f;
    var name = _a.name, _g = _a.width, width = _g === void 0 ? '100%' : _g, height = _a.height, fontSize = _a.fontSize, options = _a.options, dropdown = _a.dropdown, _h = _a.placeholder, placeholder = _h === void 0 ? '' : _h, placeholderColor = _a.placeholderColor, _j = _a.value, value = _j === void 0 ? null : _j, _k = _a.hasError, hasError = _k === void 0 ? false : _k, _l = _a.disable, disable = _l === void 0 ? false : _l, onChange = _a.onChange, _m = _a.isMobile, isMobile = _m === void 0 ? false : _m, _o = _a.placement, placement = _o === void 0 ? 'bottom-start' : _o, _p = _a.isTransparent, isTransparent = _p === void 0 ? false : _p, _q = _a.noHover, noHover = _q === void 0 ? false : _q, _r = _a.arrowDownSize, arrowDownSize = _r === void 0 ? {
        width: 20,
        height: 20
    } : _r, _s = _a.spacingElement, spacingElement = _s === void 0 ? 0 : _s, _t = _a.fieldValue, fieldValue = _t === void 0 ? 'id' : _t, _u = _a.fieldLabel, fieldLabel = _u === void 0 ? 'name' : _u, isBackgroundChecked = _a.isBackgroundChecked, background = _a.background, color = _a.color, onFocus = _a.onFocus, onBlur = _a.onBlur, selectStyle = _a.selectStyle, dropdownStyle = _a.dropdownStyle, 
    // For custom only
    customValue = _a.customValue, prefix = _a.prefix, titleDropdown = _a.titleDropdown, mobilePopupTitle = _a.mobilePopupTitle, isNewPopupBottom = _a.isNewPopupBottom, children = _a.children, _v = _a.isEnableSearchAPI, isEnableSearchAPI = _v === void 0 ? false : _v, _w = _a.msBaseUrl, msBaseUrl = _w === void 0 ? '' : _w, _x = _a.langCode, langCode = _x === void 0 ? ELanguage.VI : _x, isSortOnMobile = _a.isSortOnMobile, selectLayout = _a.selectLayout, _y = _a.notCountedAsValue, notCountedAsValue = _y === void 0 ? [] : _y;
    var selectedIndex = options.findIndex(function (option) { return JSON.stringify(option.id) === JSON.stringify(value); });
    var _z = useState(options[selectedIndex]), selectedItem = _z[0], setSelectedItem = _z[1];
    // Dropdown control
    var _0 = useState(false), showDropdown = _0[0], setShowDropdown = _0[1];
    // Mobile dialog control
    var _1 = useState(false), showDialog = _1[0], setShowDialog = _1[1];
    var _2 = useState(''), searchText = _2[0], setSearchText = _2[1];
    // Store prev value
    var prevValue = useRef(value);
    var handleToggle = function () {
        if (disable)
            return;
        if (isMobile) {
            setShowDialog(true);
            return;
        }
        setShowDropdown(function (state) { return !state; });
    };
    var handleChange = function (value) {
        var valueFromFields = {};
        var result = {};
        if (Array.isArray(fieldValue)) {
            fieldValue.forEach(function (field) { return (valueFromFields[field] = value[field]); });
            result = { value: valueFromFields };
        }
        else {
            result = { value: value[fieldValue] };
        }
        setSelectedItem(value);
        onChange(result);
        setSearchText('');
        if (isMobile) {
            setShowDialog(false);
            return;
        }
        setShowDropdown(false);
    };
    // Handle dialog action
    var handleDialogCancel = function () {
        setShowDialog(false);
    };
    var _3 = useFloating({
        placement: placement,
        position: ((_b = dropdown === null || dropdown === void 0 ? void 0 : dropdown.floatingConfig) === null || _b === void 0 ? void 0 : _b.position) || 'absolute',
        config: {
            offset: spacingElement,
            detectHidden: true,
            useWindowAsFlippingContainer: ((_c = dropdown === null || dropdown === void 0 ? void 0 : dropdown.floatingConfig) === null || _c === void 0 ? void 0 : _c.useWindowAsFlippingContainer) || false
        }
    }), refs = _3.refs, context = _3.context, FloatingPortal = _3.FloatingPortal;
    useClickAway(function () {
        setShowDropdown(false);
        setSearchText('');
        onBlur && onBlur();
    }, {
        nodeRefs: [refs.reference, refs.popup]
    });
    // Context props
    var selectRadioProps = {
        name: name,
        dropdown: dropdown,
        options: options,
        handleChange: handleChange,
        selectedItem: selectedItem,
        fieldLabel: fieldLabel
    };
    useEffect(function () {
        if (JSON.stringify(prevValue.current) === JSON.stringify(value)) {
            return;
        }
        var selectedIndex = options.findIndex(function (option) { return JSON.stringify(option.id) === JSON.stringify(value); });
        setSelectedItem(options[selectedIndex]);
    }, [value, JSON.stringify(options)]);
    useEffect(function () {
        prevValue.current = selectedItem;
    }, [selectedItem]);
    // block scroll body when dropdownDialog open
    useEffect(function () {
        if (showDialog) {
            document.body.classList.add('overflow-hidden');
            document.documentElement.classList.add('overflow-hidden');
            return;
        }
        document.body.classList.remove('overflow-hidden');
        document.documentElement.classList.remove('overflow-hidden');
        return function () {
            document.body.classList.remove('overflow-hidden');
            document.documentElement.classList.remove('overflow-hidden');
        };
    }, [showDialog]);
    // check not nullist & not in notCountedAsValue list
    var hasValueChecked = (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) != null && !notCountedAsValue.includes(selectedItem.id);
    var renderValue = function () {
        return customValue ? (customValue(selectedItem)) : (React__default.createElement(Value, { hasChecked: hasValueChecked, selectLayoutType: selectLayout === null || selectLayout === void 0 ? void 0 : selectLayout.type }, hasValueChecked ? (selectedItem.name) : (React__default.createElement(Placeholder, { color: placeholderColor }, placeholder))));
    };
    var renderPopup = function () {
        if (isNewPopupBottom) {
            return React__default.createElement(PopupBottom, { onCancel: handleDialogCancel, isOpen: showDialog, titleDropDown: titleDropdown });
        }
        return (React__default.createElement(MobileDialog, { onCancel: handleDialogCancel, mobilePopupTitle: mobilePopupTitle, langCode: langCode, msBaseUrl: msBaseUrl, isEnableSearchAPI: isEnableSearchAPI }));
    };
    return (React__default.createElement(Wrapper, { disabled: disable, width: width, id: 'multiple-radio', style: {
            position: ((_d = dropdown === null || dropdown === void 0 ? void 0 : dropdown.floatingConfig) === null || _d === void 0 ? void 0 : _d.enablePortal) ? 'static' : 'relative'
        } },
        children ? (React__default.createElement("div", { ref: refs.setReference, onClick: handleToggle, className: 'multiple-radio-container', onBlur: onBlur, style: selectStyle }, children)) : (React__default.createElement(SelectContainer, { ref: refs.setReference, isFocus: showDropdown, isError: hasError, onClick: handleToggle, disabled: disable, isTransparent: isTransparent, noHover: noHover, height: height, fontSize: fontSize, background: background, color: color, name: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.name, className: 'multiple-radio-container', onFocus: function () {
                onFocus && onFocus();
            }, onBlur: onBlur, style: selectStyle, templateCol: prefix ? 'auto 1fr auto' : undefined, hasChecked: hasValueChecked, isSortOnMobile: isSortOnMobile, selectLayoutType: selectLayout === null || selectLayout === void 0 ? void 0 : selectLayout.type, "data-input-container": true },
            prefix && prefix,
            React__default.createElement(ValueContainer, null, renderValue()),
            !isSortOnMobile ? (React__default.createElement(ArrowDownContainer, null,
                React__default.createElement(ArrowDownIcon, { width: arrowDownSize.width, height: arrowDownSize.height }))) : (React__default.createElement(ArrowDownContainer, null,
                React__default.createElement(SortMobileIcon, null))))),
        React__default.createElement(FloatingPortal, { enable: (_e = dropdown === null || dropdown === void 0 ? void 0 : dropdown.floatingConfig) === null || _e === void 0 ? void 0 : _e.enablePortal },
            React__default.createElement(MultipleRadioGroupContext.Provider, { value: selectRadioProps },
                React__default.createElement(Dropdown, { ref: refs.setPopup, placement: context.placement, style: __assign({ display: context.isReferenceHidden ? 'none' : 'block', position: context.position, left: context.x, top: context.y, width: (dropdown === null || dropdown === void 0 ? void 0 : dropdown.width) || ((_f = refs.reference.current) === null || _f === void 0 ? void 0 : _f.offsetWidth) }, dropdownStyle), searchTextState: [searchText, setSearchText], show: showDropdown, isBackgroundChecked: isBackgroundChecked, isEnableSearchAPI: isEnableSearchAPI, msBaseUrl: msBaseUrl, langCode: langCode, title: titleDropdown }),
                showDialog && renderPopup()))));
};

export { MultipleRadio as default };
//# sourceMappingURL=index.js.map
